import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  }
};

const srm20 = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">
        monoFab SRM-20 : Desktop Milling Machine
      </Typography>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./fabisp/srm20.jpg" alt="srm20" />
      </div>
      <Typography className={classes.para} paragraph>
        The below image shows [1/64] and [1/32] (inch) endmills respectively.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/endmills.jpg"
          alt="endmills"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Vigyan Ashram Fab Lab has Roland SRM 20 desktop milling machine. The
        machine specification can be found here on{" "}
        <Link
          target="_blank"
          href={
            "https://www.rolanddga.com/products/3d/srm-20-small-milling-machine/specifications"
          }
        >
          official website
        </Link>
        .
      </Typography>
      <Typography variant="h6">Line Test</Typography>
      <Typography className={classes.para} paragraph>
        As part of group assignment I teamed with{" "}
        <Link
          target="_blank"
          href={
            "http://fabacademy.org/2019/labs/vigyanashram/students/tushar-kukreja"
          }
        >
          Tushar Amar Kukreja
        </Link>
        . We got the line test images as provided in schedule and used{" "}
        <Link href={"http://fabmodules.org/"}>FabModules</Link> to generate .rml
        files.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest.png"
          alt="linetest"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest.interior.png"
          alt="linetest.interior"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest-fabmod1.jpg"
          alt="linetest"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest-fabmod2.jpg"
          alt="linetest"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest-fabmod3.jpg"
          alt="linetest"
        />
      </div>
      <Typography className={classes.para} paragraph>
        We had problem with outer cut of linetest. The FabModule didn't create
        close rectangle. This can be seen from the red line which denotes jog
        path. Black lines denote cut path.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest-fabmod4.jpg"
          alt="linetest"
        />
      </div>
      <Typography className={classes.para} paragraph>
        However, as it can be seen from the images the smallest thickness as in
        the line test was cut perfectly with the machine end-mill.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest.jpg"
          alt="linetest"
        />
      </div>
      <Typography className={classes.para} paragraph>
        The defect in .rml file resulted in no cut at bottom part of line test
        cut. Therefore, we manually cut it. The annoying thing about SRM-20
        machine was it doesn't have in-built light. We weren't sure about the
        no-cut situation even with close inspection. Our attempt to peel out the
        board resulted in damages to edges.
        <br />
        Then we removed the whole board and cut the linetest board with small
        grinding machine. The cut was not good. We stopped here, and didn't
        repeat it, as the required result was already achieved.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest1.jpg"
          alt="linetest"
        />
      </div>

      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/linetest1.jpg"
          alt="linetest"
        />
      </div>

      <Typography variant="h6">FabTinyISP - Milling </Typography>
      <Typography className={classes.para} paragraph>
        I choose{" "}
        <Link
          target="_blank"
          href={
            "http://fab.cba.mit.edu/classes/863.16/doc/projects/ftsmin/index.html"
          }
        >
          Mr. Brian
        </Link>{" "}
        I faced few problems during milling. It seems bed was not aligned
        perfectly. Hence, PCB trace was not cut at one corner.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabispmill.jpg"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        This can be fixed in two ways.
        <br />
        1. By taking the end mill back to origin and updating user z-coordinates
        by setting the cursor step to x1. Then start milling again.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/problem-z.jpg"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        2. By taking the end mill near to the corner and set gravity again. Then
        updating user z-coordinates and start milling again.
      </Typography>
      <Typography variant="h6">PCB </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp-pcb.jpg"
          alt="tinyisp"
        />
      </div>
      <Typography variant="h5">FabTinyISP - Vinyl Cutting </Typography>
      <Typography className={classes.para} paragraph>
        To make PCB in Vinyl cutter we need copper roll and OHP sheet. We can't
        cut directly on copper roll sheet as the adhesive on copper roll is very
        weak for vinyl cutting.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/vinylisp000.jpg"
          alt="tinyisp"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/vinylisp00.jpg"
          alt="tinyisp"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/vinylisp01.jpg"
          alt="tinyisp"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/vinylisp02.jpg"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        The flexible PCB is shown below.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/vinylisp03.jpg"
          alt="tinyisp"
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(srm20);
